import { useState } from 'react'
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useTheme,
  useMediaQuery,
  Stack,
  Typography,
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const navItems = [
    { label: '✨ Funcionalidades', href: '#features' },
    { label: '🔄 Como Funciona', href: '#how-it-works' },
    { label: '📞 Contato', href: '#cta' },
  ]

  return (
    <AppBar position="fixed" elevation={0}>
      <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>
        {/* Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}>
          <Typography variant="h5" sx={{ fontSize: '1.5rem' }}>
            🍽️
          </Typography>
          <Box>
            <Typography
              sx={{
                fontWeight: 900,
                fontSize: '1.25rem',
                background: 'linear-gradient(135deg, #dc2626 0%, #f97316 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Zedoprato
            </Typography>
            <Typography sx={{ fontSize: '0.625rem', color: '#9ca3af', fontWeight: 600 }}>
              Gestão de Atendimento
            </Typography>
          </Box>
        </Box>

        {/* Desktop Menu */}
        {!isMobile && (
          <Stack direction="row" spacing={1} sx={{ flex: 1, justifyContent: 'center' }}>
            {navItems.map((item) => (
              <Button
                key={item.label}
                href={item.href}
                sx={{
                  color: '#374151',
                  fontWeight: 500,
                  fontSize: '0.95rem',
                  position: 'relative',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: 0,
                    height: '2px',
                    background: 'linear-gradient(135deg, #dc2626 0%, #f97316 100%)',
                    transition: 'width 0.3s ease',
                  },
                  '&:hover::after': {
                    width: '100%',
                  },
                  '&:hover': {
                    color: '#dc2626',
                    backgroundColor: 'transparent',
                  },
                }}
              >
                {item.label}
              </Button>
            ))}
          </Stack>
        )}

        {/* CTA Button */}
        {!isMobile && (
          <Button
            variant="contained"
            color="primary"
            sx={{
              px: 3,
              py: 1.2,
            }}
          >
            Teste Grátis
          </Button>
        )}

        {/* Mobile Menu Button */}
        {isMobile && (
          <IconButton
            onClick={() => setMobileMenuOpen(true)}
            sx={{ color: '#374151' }}
          >
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
      >
        <Box sx={{ width: 280, pt: 2, px: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <IconButton
              onClick={() => setMobileMenuOpen(false)}
              sx={{ color: '#374151' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <List>
            {navItems.map((item) => (
              <ListItem
                key={item.label}
                component="a"
                href={item.href}
                onClick={() => setMobileMenuOpen(false)}
                sx={{
                  mb: 1,
                  borderRadius: '0.5rem',
                  '&:hover': {
                    backgroundColor: '#fee2e2',
                    color: '#dc2626',
                  },
                }}
              >
                <ListItemText primary={item.label} sx={{ fontWeight: 500 }} />
              </ListItem>
            ))}
          </List>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 4, py: 1.5 }}
          >
            Teste Grátis
          </Button>
        </Box>
      </Drawer>
    </AppBar>
  )
}
